module.exports = __webpack_public_path__ + "static/media/2.cc8ee93f.svg";